import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QQOtpModel } from 'src/app/models/qq-otp-model';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.scss'],
})
export class VerifyOtpComponent implements OnInit {
  @Input() quickQuote: QQQuestionnaireViewModel;
  @Input() action: string;  
  @Input() otpContentKey: string = "RetrieveQuickQuoteOtp";
  title: string;
  otpId: number;
  preferredChannel: 'Email' | 'Sms' | 'Call';
  email: string;
  mobile: string;
  error: string;
  emailRgx = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
  message: string;
  sentMessage: string = "";
  loading: boolean = false;
  otp: string;
  @Output() prev = new EventEmitter();
  @Output() next = new EventEmitter<QQOtpModel>();
  qqModel: QQOtpModel;

  constructor(
    private api: ApiService
  ) { }

  async ngOnInit() {
    this.email = this.quickQuote.answersObject['FirstPolicyHolderEmail'];
    this.mobile = this.quickQuote.answersObject['FirstPolicyHolderMobile'];
    this.preferredChannel = this.quickQuote.answersObject['PreferredChannel'];
    if (this.action == 'sendViaSms') {
      this.preferredChannel = "Sms";
      let otpModel = await this.sendOtp("", this.mobile);
      this.next.emit(otpModel);
    }
    this.title = this.preferredChannel === "Email" ? "Verify Email" : "Verify Mobile";
  }

  async saveMobile() {
    var mobile = this.mobile;
    if (!this.mobile) {
      this.error = "Please enter your phone number";
      return;
    }
    if (!/^\d{10,12}$/.test(this.mobile)) {
      this.error = "Please enter a valid phone number";
      return;
    }

    this.quickQuote.saveAnswer('FirstPolicyHolderMobile', this.mobile);
    let otpModel = await this.sendOtp("", mobile);
    this.next.emit(otpModel);
  }

  async saveEmail() {
    var email = this.email;
    if (!this.email) {
      this.error = 'Please enter your email address';
      return;
    }
    if (!this.emailRgx.test(this.email)) {
      this.error = 'Please enter a valid email address';
      return;
    }
    this.quickQuote.saveAnswer('FirstPolicyHolderEmail', this.email);
    let otpModel = await this.sendOtp(email, "");
    this.next.emit(otpModel);
  }

  async sendOtp(email: string, mobile: string): Promise<QQOtpModel> {
    try {
      this.message = this.preferredChannel === "Email" ? 'Sending one time passcode to your email' 
      : 'Sending one time passcode to your mobile phone';
      this.loading = true;
      const otp = await this.api.sendOtpQuickQuote({
        email: email,
        mobile: mobile,
        firstName: this.quickQuote.answersObject.FirstPolicyHolderFirstName,
        lastName: this.quickQuote.answersObject.FirstPolicyHolderSurName,
        siteContentKey: this.otpContentKey
      }
      );
      this.otpId = otp.otpId;
      this.loading = false;
      this.qqModel = {
        email: email,
        mobile: mobile,
        otpId: this.otpId,
        preferredChannel: this.preferredChannel
      }

      return this.qqModel;
    }
    catch (err: any) {
      this.loading = false;
      this.error = err.message;
    }
  }

  async onNext() {
    let otpModel = null;
    if (this.preferredChannel === 'Email')
      otpModel = await this.saveEmail();

    if (this.preferredChannel === 'Call' || this.preferredChannel === 'Sms')
      otpModel = await this.saveMobile();
  }

  async onPrev() {
    this.prev.emit();
  }

  async validateEmail() {
    if (!this.email) {
      this.error = 'Please enter your email address';
      return;
    }
    if (!this.emailRgx.test(this.email)) {
      this.error = 'Please enter a valid email address';
      return;
    }
  }

  async validateMobile() {
    if (!this.mobile) {
      this.error = "Please enter your phone number";
      return;
    }
    if (!/^\d{10,12}$/.test(this.mobile)) {
      this.error = "Please enter a valid phone number";
      return;
    }
  }
}
